exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-form-register[data-v-0e12b5d0]{display:flex;justify-content:center;margin-top:30px}.inputIsentoChecked[data-v-0e12b5d0]{background-color:green}.email-helper-text[data-v-0e12b5d0]{display:block;margin-bottom:6px}@media (max-width:990px){.content-form-login[data-v-0e12b5d0]{display:unset}}", ""]);

// exports
